module.exports = require('handlebars/runtime');


//////////////////
// WEBPACK FOOTER
// ./~/handlebars-template-loader/runtime/index.js
// module id = ofuD
// module chunks = 9